/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-30 14:07:13
 */
// import md5 from "js-md5";
import { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import { Login } from "@/api/interface";
import { loginApi } from "@/api/modules/login";
import { getCurrentUser } from "@/api/modules/user";
import { HOME_URL } from "@/config/config";
import { connect, useDispatch } from "react-redux";
import { setCurrentUser, setToken } from "@/redux/modules/global/action";
import { useTranslation } from "react-i18next";
import { setTabsList } from "@/redux/modules/tabs/action";
import FormLabel from "@/pages/User/components/FormLabel";

const LoginForm = (props: any) => {
	const { t } = useTranslation();
	const { setToken } = props;
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState<boolean>(false);
	const dispatch = useDispatch();
	// 登录
	const onFinish = async (loginForm: Login.ReqLoginForm) => {
		try {
			setLoading(true);
			// loginForm.password = md5(loginForm.password);
			const { data } = await loginApi(loginForm);

			setToken(data);
			localStorage.setItem("token", data);
			// setTabsList([]);
			message.success("Login success");
			getCurrentUser().then(res => {
				dispatch(setCurrentUser(res.data));
				localStorage.setItem("nickname", res.data.nickname);
			});
			navigate(HOME_URL);
		} finally {
			setLoading(false);
		}
	};

	const onFinishFailed = (errorInfo: any) => {
		console.log("Failed:", errorInfo);
	};

	return (
		<Form
			form={form}
			name="basic"
			labelCol={{ span: 5 }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			size="large"
			autoComplete="on"
			layout="vertical"
			style={{
				width: "100%"
			}}
		>
			<Form.Item
				name="username"
				label={<FormLabel text={"Email"} />}
				required={false}
				rules={[{ required: true, message: "请输入用户名" }]}
			>
				<Input placeholder="you@acme.com" />
			</Form.Item>
			<Form.Item
				name="password"
				label={<FormLabel text={"Password"} />}
				required={false}
				rules={[{ required: true, message: "请输入密码" }]}
			>
				<Input.Password autoComplete="new-password" placeholder="your password" />
			</Form.Item>
			<Form.Item className="login-btn">
				<Button
					style={{ width: "100%", height: "3rem", backgroundColor: "#565BDD" }}
					type="primary"
					htmlType="submit"
					loading={loading}
				>
					<span
						style={{
							fontFamily: "PingFang SC",
							fontWeight: 500,
							fontSize: "1rem",
							lineHeight: "2rem"
						}}
					>
						Log in
					</span>
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapDispatchToProps = { setToken, setTabsList };
export default connect(null, mapDispatchToProps)(LoginForm);
